<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>直播</span><span style="color:#D7230C;">互动</span></div>
							<div class="sm_pub">直播互动</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">直播互动</div>
				</div>
				<div class="maptop_a">
					精确搜索:
					<div class="maptop_a_a">
						<input v-model="keyword" type="text" placeholder="请输入内容">
						<div @click="selectChild1">
							搜索
						</div>
					</div>
				</div>
				<!-- <div class="Bigcosousuo" >
					<el-select @change="gotosb"  v-model="value" placeholder="请选择" style="width: 150px;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div> -->
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div style="width: 95%;margin: 0 auto;height: 950px;">
					<div v-for="(item,index) in dataList" :key="index"
						style="width: 24%;height: 350px;margin-left: 0.8%;float: left;margin-top: 15px;box-sizing: border-box;box-shadow: rgb(0 0 0 / 16%) 0px 4px 24px;"
						class="NewArrialsb" @click="tza(item)">

						<div style="height: 280px;">
							<img v-lazy=" 'https://admin.shipoe360.com/public/' + item.picture " alt=""
								style="width: 100%;height: 100%;">
						</div>

						<div style="height: 20px;text-align: center;line-height: 20px;font-weight: 700;font-size: 14px; overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;">
							{{item.title}}
						</div>

						<div
							style="height: 30px;text-align: center;line-height: 30px;font-weight: 700;font-size: 14px;color: crimson;width: 40%;margin: 0 auto;border: 1px solid #D7230C;border-radius: 5px;margin-top: 5px;">
							查看详情
						</div>

					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="PageSize" layout="total, prev, pager, next"
						:total="Totals">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				dataLists: '',
				currentPage: 1, //当前页
				PageSize: 12, //当前每页数据
				Totals: 100, //总数据条数
				keyword: '', //搜索框查询关键字
				dataList: [],
				value: '国外报刊',
				options: [{
					value: '国外报刊',
					label: '国外报刊'
				}, {
					value: '国内报刊',
					label: '国内报刊'
				}]
			}
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
		},
		async mounted() {
			this.gotosb()
		},
		methods: {
			tza(id) {
				console.log(id)
				window.open(id.url_link, '_blank');
			},
			async gotosb() {
				if (this.value == '国外报刊') {
					let res = await http.get('api/picture/zbhd_index', {

					})
					this.dataList = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				} else {
					let res = await http.get('api/picture/domestic_journals', {

					})
					this.dataList = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				}
			},
			async selectChild1() {
				if (this.keyword == '') {
					alert('请输入内容')
				}
				let res = await http.post('api/picture/mh_zbhd', {
					title: this.keyword
				})
				console.log(res)
				this.dataList = res.data.data.list
				this.Totals = res.data.data.list.total
				this.currentPage = res.data.data.list.current_page
			},
			handleSizeChange(val) {},
			async handleCurrentChange(val) {
				if (this.value == '国外报刊') {
					let res = await http.get('api/picture/mh_zbhd_page', {
						title: this.keyword,
						page: val
					})
					this.dataList = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				} else {
					let res = await http.get('api/picture/pages_domestic_journals', {
						page: val
					})
					this.dataList = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				}
			}
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1200px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}
	
	.maptop_a {
		padding-top: 0px;
		width: 400px;
		height: 50px;
		float: left;
		line-height: 45px;
		margin-left: 50px;
		font-size: 20px;
		font-weight: 800;
	}
	
	.maptop_a_a {
		width: 300px;
		height: 40px;
		float: right;
		box-sizing: border-box;
		border: 3px solid #D7230C;
		background-color: #D7230C;
	}
	
	.maptop_a_a>input {
		width: 209px;
		height: 32px;
		float: left;
		border: 0px;
		outline: none;
	}
	
	.maptop_a_a>div {
		width: 70px;
		height: 32px;
		float: left;
		line-height: 32px;
		text-align: center;
		color: #fff;
		cursor: pointer;
	}
	

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.Bigcosousuo {
		float: left;
		width: 300px;
		height: 50px;
		margin-left: 50px;
	}

	/* .Bigcosousuo>input {
		width: 65%;
		margin-left: 15px;
		height: 30px;
		float: left;
		border: 0px;
		outline: none;
	}

	.Bigcosousuo>div {
		width: 30%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
		background-color: #D7230C;
	} */

	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1100px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}
</style>
